import React, { useEffect, useState } from 'react';
import { Route, RouteProps } from 'react-router';
import auth from 'src/services/auth';
import { useTokenState, useUserDetailsFetch } from './hooks';
import NotificationAlert from '../NotificationAlert';

export type ProtectedRouteProps = { title: string } & RouteProps;

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ title, children, ...rest }) => {
  const token = useTokenState();
  const [{ data, loading, error }] = useUserDetailsFetch(token);
  const [expireWarning, setExpireWarning] = useState<string | null>(null);
  const expireWarningMessage = localStorage.getItem('expireWarningMessage');
  
  useEffect(() => {
    const isWarningClosed = sessionStorage.getItem('isWarningClosed') === 'true';
    if (!isWarningClosed && expireWarningMessage) {
      setExpireWarning(expireWarningMessage || null);
    }
    
  }, [expireWarningMessage]);

  const handleClosedStatus = () => {
    sessionStorage.setItem('isWarningClosed', 'true');
    setExpireWarning(null);
  };

  React.useEffect(() => {
    if (error) {
      auth.logout();
    }
  }, [error]);

  const dataLoaded = !loading && data !== null;
  return (
    <>
      {expireWarning && (
        <NotificationAlert
          visible={true}
          message={expireWarning.replaceAll('<br>', '')}
          onClose={handleClosedStatus}
        />
      )}
      <Route
        {...rest}
        render={() => {
          document.title = title ? title : 'QL2';
          return token && dataLoaded ? children : null;
        }}
      />
    </>
  );
};

export default ProtectedRoute;
